import jQuery from 'jquery';
import 'vendor/jquery/bootstrap-datepicker';
import DateFormatter from '../formatters/dates';

(function($, undefined) {
  // save the original function object
  var _super = $.fn.datepicker;

  // create a new constructor
  var InvocaDatepicker = function(element, options) {
    this.createIconAddon(element, options);

    // call the original constructor
    _super.Constructor.apply(this, arguments);
  };

  var defaults = $.extend(_super.defaults, {
    autoclose: true,
    iconAddon: true
  });
  var dates = _super.dates;
  var locale_opts = _super.locale_opts;
  var DPGlobal = _super.DPGlobal;
  var DateRangePicker = _super.DateRangePicker;
  var noConflict = _super.noConflict;
  var version = _super.version;

  // extend prototypes and add a super function
  InvocaDatepicker.prototype = $.extend({}, _super.Constructor.prototype, {
    constructor: InvocaDatepicker,
    _super: function() {
      var args = $.makeArray(arguments);
      _super.Constructor.prototype[args.shift()].apply(this, args);
    },

    createIconAddon: function(element, options) {
      if (options.iconAddon && !$(element).parent().hasClass("input-group")) {
        var wrapper = $("<div>", { class: "input-group" });
        var addonElement = $("<span>", { class: "input-group-append" }).css({ "line-height": "1", "cursor": "pointer" })
          .append($("<i class='input-group-text'>").icon("date_range"));
        $(element).wrap(wrapper).after(addonElement);
      }

      if ($(element).parent().hasClass("input-group")) {
        $(element).parent().find(".input-group-append").on("click", function(event) {
          event.preventDefault();
          $(element).focus();
        });
      }
    }
  });

  function optsFromEl(el, prefix) {
    // Derive options from element data-attrs
    let data = $(el).data();
    let out = {};
    let inkey;
    let replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');

    prefix = new RegExp('^' + prefix.toLowerCase());
    function re_lower(_, a) {
      return a.toLowerCase();
    }
    for (var key in data) {
      if (prefix.test(key)) {
        inkey = key.replace(replace, re_lower);
        out[inkey] = data[key];
      }
    }
    return out;
  }

  function optsFromLocale(lang) {
    // Derive options from locale plugins
    var out = {};
    // Check if "de-DE" style date is available, if not language should
    // fallback to 2 letter code eg "de"
    if (!dates[lang]) {
      lang = lang.split('-')[0];
      if (!dates[lang]) { return; }
    }
    var d = dates[lang];
    $.each(locale_opts, function(i, k) {
      if (k in d) { out[k] = d[k]; }
    });
    return out;
  }

  // override the old plugin initialization with the new constructor
  var invocaDatepickerPlugin = function(option) {
    var args = Array.apply(null, arguments);
    args.shift();
    var internal_return;
    this.each(function() {
      let $this = $(this);
      let data = $this.data('datepicker');
      let options = typeof option === 'object' && option;

      options = $.extend(options, {});
      options.format = options.format || DateFormatter.localeFormatString('datepicker');
      if (!data) {
        let elopts = optsFromEl(this, 'date');
        // Preliminary otions
        let xopts = $.extend({}, defaults, elopts, options);
        let locopts = optsFromLocale(xopts.language);
        // Options priority: js args, data-attrs, locales, defaults
        let opts = $.extend({}, defaults, locopts, elopts, options);
        if ($this.hasClass('input-daterange') || opts.inputs) {
          var ropts = {
            inputs: opts.inputs || $this.find('input').toArray()
          };
          $this.data('datepicker', (data = new DateRangePicker(this, $.extend(opts, ropts))));
        } else {
          $this.data('datepicker', (data = new InvocaDatepicker(this, opts)));
        }
      }
      if (typeof option === 'string' && typeof data[option] === 'function') {
        internal_return = data[option].apply(data, args);
        if (internal_return !== undefined) { return false; }
      }
    });
    if (internal_return !== undefined) { return internal_return; } else { return this; }
  };
  $.fn.datepicker = invocaDatepickerPlugin;

  $.fn.datepicker.Constructor = InvocaDatepicker;
  $.fn.datepicker.defaults = defaults;
  $.fn.datepicker.locale_opts = locale_opts;
  $.fn.datepicker.DPGlobal = DPGlobal;
  $.fn.datepicker.DateRangePicker = DateRangePicker;
  $.fn.datepicker.noConflict = noConflict;
  $.fn.datepicker.version = version;
}(jQuery));
